export enum Error {
  DEFAULT = 'Something went wrong. Please try again later.',
  CODE_ENTER = 'Incorrect code. Please enter valid code or get new one.',
}
